@if (businessInfo?.companyDetail?.info) {
  <section class="tw-pb-20">
    <h3 class="p-text-h3 tw-mb-5">{{ 'campaign.businessInfo' | translate }}</h3>
    <div [innerHTML]="businessInfo?.companyDetail?.info | trustSrc" class="ck-content"></div>
  </section>
}
